module.exports = __webpack_public_path__ + "static/media/dashboard-call-start-icon.97c31f3f.svg";